import PeopleIcon from "@mui/icons-material/People"
import UserCreate from "./create"
import UserEdit from "./edit"
import UserList from "./list"
import UserShow from "./show"

const options = {
    list: UserList,
    create: UserCreate,
    edit: UserEdit,
    show: UserShow,
    icon: PeopleIcon,
    //recordRepresentation: (record: any)=> `${record.name} (${record.role})`,
}

export default options
